<span i18n="Text shown in a snackbar when an unknown error occurs">
  Something went wrong. Please try again.
</span>
